export default __webpack_public_path__ + "static/media/spinner.15f59e61.gif";